import { useState } from 'react';

import { useT } from '../../i18n/index.js';
import { HelpHint } from '../../components/HelpHint.js';
import { CatalogBrowser } from './CatalogBrowser.js';
import { HardwareBuild } from './HardwareBuild.js';

type Tab = 'catalog' | 'build';

/**
 * Sous-partie « Hardware » de la page Deploy (ADR-0030) : deux onglets — le **catalogue** de pièces
 * organisé (consultation) et la **nomenclature** d'un matériel (composition). Le matériel lui-même
 * (registre de la flotte, ADR-0029) se gère depuis Overview ; ici on compose ce qu'il embarque.
 */
export function HardwareSection() {
  const t = useT();
  const [tab, setTab] = useState<Tab>('catalog');
  return (
    <section className="ddp-hardware" id="deploy-hardware">
      <div className="ddp-hardware__head">
        <h2 className="ddp-deploy__family-name">{t('deploy.hardwareLabel')}</h2>
        <HelpHint textKey="help.deploy.hardware" />
      </div>
      <p className="ddp-deploy__family-text">{t('deploy.hardwareText')}</p>

      <div className="ddp-hardware__tabs" role="tablist" aria-label={t('deploy.hardwareLabel')}>
        <button
          type="button"
          role="tab"
          className="ddp-hardware__tab"
          aria-selected={tab === 'catalog'}
          onClick={() => setTab('catalog')}
        >
          {t('hw.tab.catalog')}
        </button>
        <button
          type="button"
          role="tab"
          className="ddp-hardware__tab"
          aria-selected={tab === 'build'}
          onClick={() => setTab('build')}
        >
          {t('hw.tab.build')}
        </button>
      </div>

      {tab === 'catalog' ? <CatalogBrowser /> : <HardwareBuild />}
    </section>
  );
}
